// extracted by mini-css-extract-plugin
export default {"switcherButton":"LanguageSwitcher_switcherButton__LAO+K","switcherCode":"LanguageSwitcher_switcherCode__p8M+i"};